import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Check, AlertTriangle, Zap, Smartphone, Monitor, Tablet } from 'lucide-react';
export function OfferPricing() {
  return <section id="oferta" className="py-20 px-4 bg-[#FEFBF4]" data-id="element-184">
      <div className="max-w-4xl mx-auto" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl shadow-2xl overflow-hidden border border-[#D97706]/20 relative" data-id="element-186">
          {/* Top Banner */}
          <div className="bg-[#1B4332] text-white text-center py-4 px-4" data-id="element-187">
            <span className="font-bold tracking-wider uppercase text-sm md:text-base" data-id="element-188">
              Oferta especial por tiempo limitado
            </span>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-189">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1B4332] mb-8" data-id="element-190">
              Llevate Todo El Pack Completo Hoy
            </h2>

            {/* Value Stack Summary */}
            <div className="bg-gray-50 rounded-xl p-6 max-w-lg mx-auto mb-8 text-left space-y-3 border border-gray-100" data-id="element-191">
              <div className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-192">
                <span className="text-[#1C1917] font-medium" data-id="element-193">
                  3 Guías Prácticas principales
                </span>
                <span className="text-gray-500 font-semibold" data-id="element-194">$84.97</span>
              </div>
              <div className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-195">
                <span className="text-[#1C1917] font-medium" data-id="element-196">
                  14 Bonus y herramientas
                </span>
                <span className="text-gray-500 font-semibold" data-id="element-197">$230.85</span>
              </div>
              <div className="flex justify-between items-center text-lg" data-id="element-198">
                <span className="text-[#1C1917] font-bold" data-id="element-199">Valor total</span>
                <span className="text-red-500 font-bold line-through decoration-2" data-id="element-200">
                  $315.82
                </span>
              </div>
            </div>

            {/* Price Display */}
            <div className="mb-8" data-id="element-201">
              <div className="inline-block bg-[#86EFAC] text-[#1B4332] px-4 py-1 rounded-full text-sm font-bold mb-4" data-id="element-202">
                Ahorrás más del 90%
              </div>
              <div className="flex items-center justify-center gap-2" data-id="element-203">
                <span className="text-2xl text-gray-500 font-medium" data-id="element-204">
                  Hoy: Solo
                </span>
                <span className="text-6xl font-bold text-[#D97706] tracking-tight" data-id="element-205">
                  $12.99
                </span>
              </div>
            </div>

            {/* CTA */}
            <div className="mb-6" data-id="element-206">
              <CTAButton text="SÍ, QUIERO MI PACK COMPLETO" size="xl" pulse={true} href="https://guiaspracticas.store/cart/51246575124770:1?checkout" onClick={() => {
              if (typeof (window as any).fbq === 'function') {
                ;
                (window as any).fbq('track', 'AddToCart');
              }
            }} className="w-full md:w-auto min-w-[300px]" data-id="element-207" />
            </div>

            {/* Trust Elements */}
            <div className="flex flex-col items-center gap-4 text-sm text-gray-500" data-id="element-208">
              <div className="flex items-center gap-2" data-id="element-209">
                <Zap className="w-4 h-4 text-[#D97706]" data-id="element-210" />
                <span data-id="element-211">Acceso inmediato después del pago</span>
              </div>
              <div className="flex items-center gap-4" data-id="element-212">
                <span className="flex items-center gap-1" data-id="element-213">
                  <Monitor className="w-4 h-4" data-id="element-214" /> PC
                </span>
                <span className="flex items-center gap-1" data-id="element-215">
                  <Tablet className="w-4 h-4" data-id="element-216" /> Tablet
                </span>
                <span className="flex items-center gap-1" data-id="element-217">
                  <Smartphone className="w-4 h-4" data-id="element-218" /> Celular
                </span>
              </div>
            </div>
          </div>

          {/* Bottom Warning */}
          <div className="bg-[#FFFBEB] p-4 text-center border-t border-[#FCD34D]" data-id="element-219">
            <p className="text-sm text-[#92400E] flex items-center justify-center gap-2" data-id="element-220">
              <AlertTriangle className="w-4 h-4" data-id="element-221" />
              Los bonus premium (Comunidad + Masterclass) podrían dejar de
              incluirse en cualquier momento.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}